import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { deleteEmpProfileAlbumsApi } from "../../API/API";

function* deleteEmpAlbumsSaga(params) {
  try {
    const response = yield call(deleteEmpProfileAlbumsApi, params);
    yield put({
      type: types.DELETE_EMP_ALBUMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.DELETE_EMP_ALBUMS_FAILURE, payload: error?.response });
  }
}

export function* watchDeleteEmpAlbumsSaga() {
  yield takeEvery(types.DELETE_EMP_ALBUMS_REQUESTED, deleteEmpAlbumsSaga);
}
